export default __webpack_public_path__ + "static/media/no_bg_loader.937bd4bb.gif";